import { useEffect, useMemo, useState } from 'react'
import { Badge } from 'antd'
import api from '@utils/api'
import './alerts.css'
import { BellFilled } from '@ant-design/icons'
import { UserSummary } from '../UserSummary'
import { ControlPanel } from './ControlPanel'
import { TrailerSwapSummary } from './TrailerSwapSummary'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useMarkets } from '@api/useMarkets'
import { getCurrentMarket, setCurrentMarket } from '@utils/general'
import { useUserSettings } from '@hooks/settings'
import { GraviButton, Horizontal, useDeviceType } from '@gravitate-js/excalibrr'
import { useSiteAlerts } from './useSiteAlerts'

export const panelModes = {
  DEFAULT: 'default',
  TRAILERSWAPDETAILS: 'trailerSwapDetails',
}

export const UserControlPanel = () => {
  let currentMarket = getCurrentMarket() || ''

  const [visible, setVisible] = useState(false)
  const [mode, setMode] = useState(panelModes.DEFAULT)
  const [selectedAlert, setSelectedAlert] = useState()
  const { scopes } = useSecurityContext()
  const { useMarketsQuery } = useMarkets()
  const { data: marketData } = useMarketsQuery()
  const { updateSetting } = useUserSettings()
  const { isMobile } = useDeviceType()
  const { siteAlertsResponse } = useSiteAlerts()

  const hasAssignedSites = useMemo(() => scopes.store_ids?.length > 0, [scopes.store_ids])
  const showDrawer = () => {
    setVisible(true)
  }
  const onClose = () => {
    setVisible(false)
  }

  useEffect(() => {
    if (scopes && scopes.market_names?.length && !scopes.market_names?.includes(currentMarket)) {
      setCurrentMarket(scopes.market_names[0])
      currentMarket = scopes.market_names[0]
      updateSetting('currentMarket', scopes.market_names[0]).then()
    }
  }, [scopes?.market_names, currentMarket])

  if (mode === panelModes.TRAILERSWAPDETAILS) {
    return <TrailerSwapSummary setMode={setMode} selectedAlert={selectedAlert} />
  }
  return (
    <>
      <Horizontal
        onClick={showDrawer}
        style={{
          minWidth: isMobile ? 'auto' : 180,
          marginRight: !isMobile && -10,
        }}
        className='px-3 items-center control-panel-trigger'
      >
        {!hasAssignedSites && (
          <Badge count={siteAlertsResponse?.unresolved_count}>
            <GraviButton icon={<BellFilled style={{ fontSize: 16 }} />} shape='circle' />
          </Badge>
        )}
        <UserSummary scopes={scopes} isMobile={isMobile} />
      </Horizontal>
      <ControlPanel
        hasAssignedSites={hasAssignedSites}
        onClose={onClose}
        visible={visible}
        setMode={setMode}
        setSelectedAlert={setSelectedAlert}
        marketData={marketData}
      />
    </>
  )
}
